export default __webpack_public_path__ + "static/media/Labs.188a8112.svg";